export default {
    breadcrumbs: {
        referrals: 'Referrals pool',
        received: 'Received',
        made: 'Made',
    },
    miles_away: 'miles away',
    your_proposed_slots: 'Your proposed time slots:',
    you_did_not_propose: 'You did not propose time slots',
    choose_provider: 'Please choose provider and confirm time slot',
    choose_provider_slots: 'Review proposed time slots',
    update_patient_choose_provider: 'Please update patient information and confirm time slot',
    select_referral_slots: 'Select Appointment Slot',
    required_fields_error: 'Please fill out all required fields.*',
    propose_time: 'Propose time',
    current_referral: 'Current referral',
    send_to_patient_provider: 'Send to patient and provider',
    selected_slots: 'Selected time slots:',
    proposed_slots: 'Proposed time slots:',
    please_select_3_time_slots: 'Please select dates and propose 3 times slots',
    accept_and_propose_time: 'Accept and propose time?',
    constrained_modal_check_again: 'Check again',
    propose_page: {
        title: 'Propose times',
        heading: 'Propose {count} times for {name}',
        heading_no_name: 'Propose {count} times',
        back: 'Back to request',
        wants: 'Wants',
        visit: 'Visit',
        telehealth: 'Telehealth',
        in_person: 'In person',
        sent_notice: 'Your times were sent. You will be notified when the patient chooses one.',
    },
    propose_picker: {
        choose_times: 'Choose times',
        previous_week: 'Previous week',
        next_week: 'Next week',
        day_closed: 'Closed',
        day_picked: 'picked',
        day_open: '1 open | {count} open',
        morning: 'Morning',
        afternoon: 'Afternoon',
        booked: '{time} · booked',
        booked_short: 'booked',
        no_open_times: 'No open times in the next 12 weeks. Add availability for this location first.',
        no_times_this_day: 'No open times this day. Pick another day above.',
        your_picks: 'Your picks',
        your_picks_count: 'Your picks ({count}/{max})',
        clear_all: 'Clear all',
        remove: 'Remove {slot}',
        pick_placeholder: 'Pick time {number}',
        same_day_tip: 'Tip: times on different days give the patient more real choice.',
        pick_more: 'Pick 1 more time | Pick {count} more times',
        send: 'Send {count} times to patient',
        patient_picks_one: 'The patient picks one of these times.',
    },
}
